import { Locale } from '@core/constants/locales.constants';
import { ObjectValues } from '@stadionhq-v3/core';

export type ArticlePageStaticParams = {
  params: {
    locale: Locale;
  };
  bypassLimit?: boolean;
};

export type ArticlePageParams = Pick<ArticlePageStaticParams, 'params'> & {
  params: { article: string };
};

export const ARTICLE_FORMATS = {
  NEWS: 'News',
  VIDEO: 'Video',
  GALLERY: 'Gallery',
  PODCAST: 'Podcast',
} as const;

export type ArticleFormat = ObjectValues<typeof ARTICLE_FORMATS>;
